module.exports = __webpack_public_path__ + "img/ad2x.c2d74760.png";